var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "grid-view",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SOPReceiver"),
        width: "980px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "margin-bottom": "3px" } },
          [
            _vm.action === _vm.ActionEnum.LOOK
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "1" },
                    on: { click: _vm.toAddReceiver }
                  },
                  [_vm._v(_vm._s(_vm.$t("Partners.btnAdd")))]
                )
              : _c(
                  "el-button",
                  {
                    attrs: { type: "primary", no: "2" },
                    on: { click: _vm.toCancel }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                ),
            _c(
              "el-checkbox",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cBoxShow,
                    expression: "cBoxShow"
                  }
                ],
                staticStyle: { "align-self": "center", "margin-left": "10px" },
                attrs: { no: "3" },
                model: {
                  value: _vm.cBoxSelected,
                  callback: function($$v) {
                    _vm.cBoxSelected = $$v
                  },
                  expression: "cBoxSelected"
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirmed")))]
            ),
            _vm.action === _vm.ActionEnum.LOOK
              ? _c(
                  "el-button",
                  {
                    staticStyle: { "margin-left": "auto" },
                    attrs: { type: "danger", no: "4" },
                    on: { click: _vm.toClearReceiver }
                  },
                  [_vm._v(_vm._s(_vm.$t("queryJob.Clear")))]
                )
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "section grid-wrapper" },
          [
            _c("cargo-ag-grid", {
              style: {
                height: _vm.action === _vm.ActionEnum.LOOK ? "350px" : "150px"
              },
              attrs: {
                "config-module": "130143",
                "grid-options": _vm.notifyExtGrid.gridOptions,
                "column-defs": _vm.notifyExtGrid.columnDefs,
                "row-data": _vm.contactList
              },
              on: {
                gridReady: function(params) {
                  _vm.notifyExtGrid.gridApi = params.api
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.action !== _vm.ActionEnum.LOOK,
                expression: "action!==ActionEnum.LOOK"
              }
            ],
            staticStyle: { display: "flex", "flex-direction": "column" }
          },
          [
            _c("div", [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "align-items": "center",
                    "padding-bottom": "10px"
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.action === _vm.ActionEnum.ADD,
                          expression: "action===ActionEnum.ADD"
                        }
                      ],
                      attrs: { no: "4" },
                      model: {
                        value: _vm.addMode,
                        callback: function($$v) {
                          _vm.addMode = $$v
                        },
                        expression: "addMode"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("Message.AddFromPartner")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("Message.AddManually")))
                      ])
                    ],
                    1
                  ),
                  _c(
                    "el-checkbox",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.action === _vm.ActionEnum.EDIT ||
                            _vm.addMode === 1,
                          expression:
                            "action === ActionEnum.EDIT || addMode === 1"
                        }
                      ],
                      staticStyle: { "margin-left": "15px" },
                      model: {
                        value: _vm.syncContact,
                        callback: function($$v) {
                          _vm.syncContact = $$v
                        },
                        expression: "syncContact"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Partners.syncContact")))]
                  )
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.action === _vm.ActionEnum.ADD && _vm.addMode === 0,
                    expression: "action===ActionEnum.ADD&&addMode===0"
                  }
                ],
                staticClass: "section grid-wrapper"
              },
              [
                _c("cargo-ag-grid", {
                  staticStyle: { height: "150px" },
                  attrs: {
                    "config-module": "130144",
                    "grid-options": _vm.usageGrid.gridOptions,
                    "column-defs": _vm.usageGrid.columnDefs,
                    "row-data": _vm.usageGrid.rowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.usageGrid.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.action === _vm.ActionEnum.EDIT || _vm.addMode === 1,
                    expression: "action===ActionEnum.EDIT||addMode===1"
                  }
                ],
                attrs: { "label-width": "90px", "label-position": "left" }
              },
              [
                _c(
                  "div",
                  { staticClass: "el-form-item-wrapper" },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Tool.UserName") + "：",
                          required: ""
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { no: "5" },
                          model: {
                            value: _vm.form.contactPerson,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "contactPerson", $$v)
                            },
                            expression: "form.contactPerson"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Partners.pushNode") + "：" } },
                      [
                        _c(
                          "el-dropdown",
                          {
                            attrs: {
                              placement: "bottom-start",
                              trigger: "click"
                            },
                            on: { "visible-change": _vm.onPushNodeChange }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "el-dropdown-link" },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "200px" },
                                  attrs: {
                                    value: _vm.getPushNodeLabel(
                                      _vm.form.pushNode
                                    ),
                                    no: "6"
                                  }
                                })
                              ],
                              1
                            ),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c("cargo-ag-grid", {
                                  staticStyle: {
                                    width: "350px",
                                    height: "300px",
                                    "padding-left": "2px"
                                  },
                                  attrs: {
                                    "show-side-bar": false,
                                    "grid-options":
                                      _vm.pushNodeTree.gridOptions,
                                    "row-data": _vm.pushNodeTreeRowData
                                  },
                                  on: {
                                    gridReady: function(params) {
                                      _vm.pushNodeTree.gridApi = params.api
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "vertical-align": "middle"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "line-height": "30px",
                                  "margin-left": "5px"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning orange"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("Message.emptySopNodeWarning")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("Message.ReceivingMethod") } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "200px" },
                            attrs: { no: "7" },
                            model: {
                              value: _vm.form.pushMode,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "pushMode", $$v)
                              },
                              expression: "form.pushMode"
                            }
                          },
                          [
                            _c("el-option", {
                              attrs: { label: _vm.$t("Viewer.email"), value: 0 }
                            }),
                            _c("el-option", {
                              attrs: {
                                label: _vm.$t("Partners.shortMessage"),
                                value: 1
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("SeaExport.Email2") + "：",
                          required: _vm.emailMode
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { no: "8" },
                          model: {
                            value: _vm.form.email,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "email", $$v)
                            },
                            expression: "form.email"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("Message.CellPhoneNumber"),
                          required: _vm.phoneMode
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { no: "9" },
                          model: {
                            value: _vm.form.mobile,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mobile", $$v)
                            },
                            expression: "form.mobile"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("queryJob.route") } },
                      [
                        _c("cargo-advance-select", {
                          staticStyle: { width: "200px" },
                          attrs: {
                            "select-type": _vm.TYPE_NAMES.basic_data_Region,
                            filterable: "",
                            "default-value": _vm.form.airline,
                            no: "10"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.airline = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: _vm.$t("CargoMsg.Cargo_RpaAccount") } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { no: "rpaAccount" },
                          model: {
                            value: _vm.form.rpaAccount,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "rpaAccount", $$v)
                            },
                            expression: "form.rpaAccount"
                          }
                        }),
                        _c(
                          "el-checkbox",
                          {
                            staticStyle: { "margin-left": "10px" },
                            attrs: { no: "enableEnterpriseWechat" },
                            model: {
                              value: _vm.form.enableEnterpriseWechat,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.form,
                                  "enableEnterpriseWechat",
                                  $$v
                                )
                              },
                              expression: "form.enableEnterpriseWechat"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_PushEnterpriseWechat")
                              )
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("CargoMsg.Cargo_WechatGroupName")
                        }
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { no: "wechatGroupName" },
                          model: {
                            value: _vm.form.wechatGroupName,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "wechatGroupName", $$v)
                            },
                            expression: "form.wechatGroupName"
                          }
                        }),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              display: "inline-block",
                              "vertical-align": "middle"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "line-height": "30px",
                                  "margin-left": "5px"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-warning orange"
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_EnterpriseWechatSopTip"
                                      )
                                    ) +
                                    " "
                                )
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ],
          1
        )
      ]),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.action !== _vm.ActionEnum.LOOK,
              expression: "action!==ActionEnum.LOOK"
            }
          ],
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "11" },
              on: { click: _vm.confirmHandler }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }